export const setCampus = (campus) => {
    return {
        type: "SET_CAMPUS",
        payload: campus
    };
};